import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import { serialize, parse as _parse } from "cookie";
import config from "@/lib/config";

var Cookies = /*#__PURE__*/function () {
  function Cookies(req, res) {
    _classCallCheck(this, Cookies);

    this.req = req;
    this.res = res;
  }

  _createClass(Cookies, [{
    key: "set",
    value: function set(values) {
      var _this$res$getHeader;

      if (!(values instanceof Array)) {
        values = [values];
      }

      var existsCookies = (_this$res$getHeader = this.res.getHeader("Set-Cookie")) !== null && _this$res$getHeader !== void 0 ? _this$res$getHeader : [];
      var cookies = Array.from(values).map(function (_ref) {
        var name = _ref.name,
            value = _ref.value,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options;
        return serialize(name, value, Object.assign({}, config.cookieOptions, options));
      });
      this.res.setHeader("Set-Cookie", [].concat(_toConsumableArray(existsCookies), _toConsumableArray(cookies)));
    }
  }, {
    key: "remove",
    value: function remove(names) {
      if (!(names instanceof Array)) {
        names = [names];
      }

      this.set(Array.from(names).map(function (name) {
        if (name instanceof Array) {
          return {
            name: name[0],
            value: "",
            options: Object.assign({
              maxAge: 0
            }, name[1])
          };
        } else {
          return {
            name: name,
            value: "",
            options: {
              maxAge: 0
            }
          };
        }
      }));
    }
  }, {
    key: "get",
    value: function get(name) {
      var cookies = this.parse();
      return cookies[name];
    }
  }, {
    key: "parse",
    value: function parse() {
      var _this$req$headers;

      if (this.req.cookies) return this.req.cookies;
      var cookie = (_this$req$headers = this.req.headers) === null || _this$req$headers === void 0 ? void 0 : _this$req$headers.cookie;
      return _parse(cookie || "");
    }
  }]);

  return Cookies;
}();

export { Cookies as default };